import { Dispatch, SetStateAction } from 'react';
import Image from 'next/future/image';
import TrustpilotRating from '../landing/TrustpilotRating';
import payoutIcon from '@/public/icons/buyback/payout.svg';
import hassleFreeIcon from '@/public/icons/buyback/hassle-free.svg';
import dataIcon from '@/public/icons/buyback/data.svg';
import Modal from '../Modal';

const DATA = [
  {
    icon: payoutIcon,
    title: 'Highest Payout',
    description:
      'We ignite competition among 100+ sellers vying for your device, ensuring you get the best deal. Sell smart, earn more.',
  },
  {
    icon: hassleFreeIcon,
    title: 'Hassle free',
    description:
      "Our platform is user-friendly, allowing you to track every step. Changed your mind? We'll ship your device back for free.",
  },
  {
    icon: dataIcon,
    title: 'Expert data erasure',
    description:
      'We ensure your sensitive information are completely wiped from your device before resale, safeguarding your privacy and security.',
  },
];

export default function SatisfactionModal({
  showModal,
  setShowModal,
}: Readonly<{
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}>) {
  return (
    <Modal
      showModal={showModal}
      setShowModal={setShowModal}
      title="Reebelo Satisfaction Promise"
    >
      <div className="flex-1 overflow-auto">
        <div className="bg-[#F5FFFF] p-4">
          <TrustpilotRating />
        </div>
        <div className="flex flex-col gap-8 p-4 sm:p-8">
          {DATA.map((item) => (
            <div className="flex flex-col gap-4 sm:flex-row" key={item.title}>
              <div className="h-6 w-6 shrink-0">
                <Image
                  alt={item.title}
                  src={item.icon}
                  height={30}
                  width={30}
                  className="h-full w-full object-contain"
                />
              </div>
              <div>
                <h4 className="text-base font-bold">{item.title}</h4>
                <p className="mt-2 text-gray-700/70">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
